"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var BlockIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(BlockIcon, _React$PureComponent);

  function BlockIcon() {
    _classCallCheck(this, BlockIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(BlockIcon).apply(this, arguments));
  }

  _createClass(BlockIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'block-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M0,4.99650051 C0,4.81627175 0.19500975,4.69902615 0.361018051,4.78041979 L0.361018051,4.78041979 L4.69723486,6.88115077 C5.03625181,7.04490701 5.25026251,7.38114024 5.25026251,7.7474116 L5.25026251,7.7474116 L5.25026251,11.7579861 C5.25026251,11.9382149 5.05425271,12.0544915 4.88824441,11.9740668 L4.88824441,11.9740668 L0.552027601,9.87333585 C0.214010701,9.70861064 0,9.37334637 0,9.00707501 L0,9.00707501 Z M11.6389819,4.78041979 C11.8049902,4.69999512 12,4.81724072 12,4.99746948 L12,4.99746948 L12,9.00707501 C12,9.37334637 11.7859893,9.70861064 11.4479724,9.87333585 L11.4479724,9.87333585 L7.11175559,11.9740668 C6.94574729,12.0544915 6.74973749,11.9382149 6.74973749,11.7579861 L6.74973749,11.7579861 L6.74973749,7.74838057 C6.74973749,7.38114024 6.96374819,7.04490701 7.30276514,6.88115077 L7.30276514,6.88115077 Z M5.54487724,1.10259022 C5.82589129,0.965965187 6.15690785,0.965965187 6.43892195,1.10162125 L6.43892195,1.10162125 L10.7131357,3.16940718 C10.8981449,3.25855259 10.8981449,3.51339219 10.7131357,3.6025376 L10.7131357,3.6025376 L6.44692235,5.67032354 C6.1659083,5.8059796 5.83389169,5.8059796 5.55287764,5.67032354 L5.55287764,5.67032354 L1.28466423,3.60156863 C1.10165508,3.51242322 1.10165508,3.25758362 1.28466423,3.16843821 L1.28466423,3.16843821 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return BlockIcon;
}(_react.default.PureComponent);

exports.default = BlockIcon;
BlockIcon.defaultProps = {
  color: 'inherit'
};
BlockIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};